import { h } from 'preact';
import htm from 'htm';

const html = htm.bind(h);

export function ScheduleScreen() {
    return html`
        <div id="schedule-screen" class="screen" style="display: none;">
            <h2>Scheduling</h2>

            <div class="schedule-controls">
                <div class="tabs">
                    <button id="tab-find" class="tab-btn active">Find Events</button>
                    <button id="tab-manage" class="tab-btn">My Events</button>
                    <button id="tab-create" class="tab-btn">Create Event</button>
                </div>
            </div>

            <div id="view-find" class="schedule-view">
                <div class="search-box">
                    <button id="btn-near-me" class="btn btn-secondary">
                        <svg viewBox="0 0 24 24" width="20" height="20" style="margin-right:8px; vertical-align:middle;">
                            <path
                                fill="currentColor"
                                d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7 7-7z"
                            />
                        </svg>
                        Events Near Me
                    </button>
                    <div class="divider"><span>OR</span></div>
                    <div class="form-group" style="margin-bottom:0;">
                        <input type="text" id="search-zip" placeholder="Enter Zip Code" />
                    </div>
                    <button id="btn-search-zip" class="btn btn-primary" style="margin-top:10px;">Search</button>
                </div>

                <h3>Upcoming Events</h3>

                <div class="view-toggle-container" style="display: flex; justify-content: flex-end; margin-bottom: 15px;">
                    <div class="view-toggle">
                        <button id="btn-view-list" class="toggle-btn active" onClick=${() => window.toggleEventView('list')}>List</button>
                        <button id="btn-view-map" class="toggle-btn" onClick=${() => window.toggleEventView('map')}>Map</button>
                    </div>
                </div>

                <div id="events-list" class="events-list">
                    <div class="empty-state">Search to find events near you.</div>
                </div>

                <div
                    id="events-map-container"
                    style="display: none; height: 400px; width: 100%; border-radius: 12px; z-index: 1;"
                ></div>
            </div>

            <div id="view-manage" class="schedule-view" style="display: none;">
                <h3>My Events</h3>
                <div id="my-events-list" class="events-list">
                    <div class="empty-state">You haven't created any events yet.</div>
                </div>

                <h3>My Upcoming RSVPs</h3>
                <div id="my-rsvps-list" class="events-list" style="margin-bottom: 30px;">
                    <div class="empty-state">You haven't RSVP'd to any upcoming events yet.</div>
                </div>

                <h3>Events from My Groups</h3>
                <div id="group-events-section" class="events-list" style="margin-bottom: 30px;"></div>
            </div>

            <div id="view-create" class="schedule-view" style="display: none;">
                <div class="auth-container">
                    <form id="create-event-form">
                        <div class="form-group">
                            <label for="evt-title">Event Title</label>
                            <input type="text" id="evt-title" required />
                        </div>
                        <div class="form-group">
                            <label for="evt-date">Date</label>
                            <input type="date" id="evt-date" required />
                        </div>
                        <div class="form-group">
                            <label for="evt-time">Time</label>
                            <input type="time" id="evt-time" required />
                        </div>
                        <div class="form-group">
                            <label for="evt-location">Location (Zip Code)</label>
                            <input type="text" id="evt-location" required pattern="[0-9]{5}" title="Five digit zip code" />
                        </div>
                        <div class="form-group">
                            <label for="evt-group">Group (Optional)</label>
                            <select id="evt-group">
                                <option value="">No Group</option>
                            </select>
                            <button type="button" id="create-new-group-link" class="btn-link">+ Create New Group</button>
                        </div>
                        <div class="form-group">
                            <label for="evt-open-to">Who Can RSVP?</label>
                            <select id="evt-open-to">
                                <option value="everyone">Everyone</option>
                                <option value="group-members">Group Members Only</option>
                            </select>
                            <small style="display: block; margin-top: 5px; color: var(--text-secondary);">
                                Group Members Only requires selecting a group above.
                            </small>
                        </div>
                        <button type="submit" class="btn btn-primary">Create Event</button>
                    </form>
                </div>
            </div>
        </div>
    `;
}
